import { generateOfferLetterPDF } from './offerLetterGenerator';
import { pdfToPageImages } from './pdfPageImages';
import { loadPdfJs } from "./pdfEngines";

// Set up pdf.js worker using unpkg CDN with correct version

// Convert PDF bytes to image using pdf.js
async function convertPdfToImage(pdfBytes) {
  const loadingTask = (await loadPdfJs()).getDocument({ data: pdfBytes });
  const pdf = await loadingTask.promise;
  
  // Get the first page
  const page = await pdf.getPage(1);
  
  // Set scale for good quality preview
  const scale = 2;
  const viewport = page.getViewport({ scale });
  
  // Create a canvas to render the PDF page
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');
  canvas.width = viewport.width;
  canvas.height = viewport.height;
  
  // Render the page to canvas
  await page.render({
    canvasContext: context,
    viewport: viewport
  }).promise;
  
  // Convert canvas to image data URL
  const imageDataUrl = canvas.toDataURL('image/png', 0.9);
  
  return imageDataUrl;
}

// All pages, for the in-app preview modal's page slider
export const generateOfferLetterPreviewPages = async (formData) => {
  try {
    const pdfBytes = await generateOfferLetterPDF(formData, true);
    return await pdfToPageImages(pdfBytes);
  } catch (error) {
    console.error("Error generating Offer Letter preview pages:", error);
    throw error;
  }
};

// Generate offer letter preview with watermark
export const generateOfferLetterPreview = async (formData) => {
  try {
    // Generate PDF with preview watermark
    const pdfBytes = await generateOfferLetterPDF(formData, true);
    
    // Convert PDF to image for preview display
    const imageDataUrl = await convertPdfToImage(pdfBytes);
    
    return imageDataUrl;
    
  } catch (error) {
    console.error("Error generating Offer Letter preview:", error);
    throw error;
  }
};
